import { isEqual } from 'lodash';
import { useAppSelector } from '../../redux/hooks';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import { useContext } from 'react';

export const useIfspUnsavedChanges = () => {
  const ifspClientDetails = useAppSelector((state) => state.ifspClientDetails);
  const ifspDailyRoutineReportDetails = useAppSelector(
    (state) => state.ifspDailyRoutineReportDetails,
  );
  const ifspDevelopmentSummaryReportDetails = useAppSelector(
    (state) => state.ifspDevelopmentSummaryReportDetails,
  );
  const ifspFamilyConcernsReportDetails = useAppSelector(
    (state) => state.ifspFamilyConcernReportDetails,
  );
  const ifspHealthSummaryReportDetails = useAppSelector(
    (state) => state.ifspHealthSummaryReportDetails,
  );
  const ifspOutcomes = useAppSelector((state) => state.ifspOutComes);
  const ifspSDPAndConsent = useAppSelector((state) => state.ifspSDPAndConsent);
  const ifspTransitionData = useAppSelector(
    (state) => state.ifspTransitionDetails,
  );
  const ifspUnsavedFields = useAppSelector((state) => state.ifspUnsavedFields);
  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);

  const isCommonAreaChanged = !isEqual(
    ifspClientDetails.ifspClientDetails,
    ifspClientDetails.originalIfspClientDetails,
  );

  const isIfspReportChanged = !isEqual(
    ifspDailyRoutineReportDetails.ifspDailyRoutineReport,
    ifspDailyRoutineReportDetails.originalIfspDailyRoutineReport,
  );
  const isDailyRoutineChanged = !isEqual(
    ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines,
    ifspDailyRoutineReportDetails.originalIfspDailyRoutineReport.dailyRoutines,
  );

  const isDevelopmentalSummaryChanged = !isEqual(
    ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport,
    ifspDevelopmentSummaryReportDetails.originalIfspDevelopmentSummaryReport,
  );

  const isFamilyConcernsChanged = !isEqual(
    ifspFamilyConcernsReportDetails.ifspFamilyConcernReport,
    ifspFamilyConcernsReportDetails.originalIfspFamilyConcernReport,
  );

  const isHealthSummaryChanged = !isEqual(
    ifspHealthSummaryReportDetails.ifspHealthSummaryReport,
    ifspHealthSummaryReportDetails.originalIfspHealthSummaryReport,
  );

  const isLastDailyRoutineChangedAndNoCreatedDate =
    !isEqual(
      ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines[
        ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines
          .length - 1
      ],
      ifspDailyRoutineReportDetails.originalIfspDailyRoutineReport
        .dailyRoutines[
        ifspDailyRoutineReportDetails.originalIfspDailyRoutineReport
          .dailyRoutines.length - 1
      ],
    ) &&
    !ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines[
      ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines
        .length - 1
    ].sessionReviewedDate;

  const isDevelopmentalSummaryChangedAndNoCreatedDate =
    !isEqual(
      ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
        .developmentalSummary[
        ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
          .developmentalSummary.length - 1
      ],
      ifspDevelopmentSummaryReportDetails.originalIfspDevelopmentSummaryReport
        .developmentalSummary[
        ifspDevelopmentSummaryReportDetails.originalIfspDevelopmentSummaryReport
          .developmentalSummary.length - 1
      ],
    ) &&
    !ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
      .developmentalSummary[
      ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
        .developmentalSummary.length - 1
    ].sessionReviewedDate;

  const isFamilyConcernsChangedAndNoCreatedDate =
    !isEqual(
      ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns[
        ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns
          .length - 1
      ],
      ifspFamilyConcernsReportDetails.originalIfspFamilyConcernReport
        .familyConcerns[
        ifspFamilyConcernsReportDetails.originalIfspFamilyConcernReport
          .familyConcerns.length - 1
      ],
    ) &&
    !ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns[
      ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns
        .length - 1
    ].sessionReviewedDate;

  const isHealthSummaryChangedAndNoCreatedDate =
    !isEqual(
      ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary[
        ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary
          .length - 1
      ],
      ifspHealthSummaryReportDetails.originalIfspHealthSummaryReport
        .healthSummary[
        ifspHealthSummaryReportDetails.originalIfspHealthSummaryReport
          .healthSummary.length - 1
      ],
    ) &&
    !ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary[
      ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary
        .length - 1
    ].sessionReviewedDate;

  const isDailyRoutineCreatedLocally =
    ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines.length >
      1 &&
    !ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines[
      ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines
        .length - 1
    ]?.id &&
    !ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines[
      ifspDailyRoutineReportDetails.ifspDailyRoutineReport.dailyRoutines
        .length - 1
    ]?.sessionReviewedDate;

  const isDevelopmentalSummaryCreatedLocally =
    ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
      .developmentalSummary.length > 1 &&
    !ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
      .developmentalSummary[
      ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
        .developmentalSummary.length - 1
    ]?.id &&
    !ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
      .developmentalSummary[
      ifspDevelopmentSummaryReportDetails.ifspDevelopmentSummaryReport
        .developmentalSummary.length - 1
    ]?.sessionReviewedDate;

  const isFamilyConcernsCreatedLocally =
    ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns
      .length > 1 &&
    !ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns[
      ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns
        .length - 1
    ]?.id &&
    !ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns[
      ifspFamilyConcernsReportDetails.ifspFamilyConcernReport.familyConcerns
        .length - 1
    ]?.sessionReviewedDate;

  const isHealthSummaryCreatedLocally =
    ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary
      .length > 1 &&
    !ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary[
      ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary
        .length - 1
    ]?.id &&
    !ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary[
      ifspHealthSummaryReportDetails.ifspHealthSummaryReport.healthSummary
        .length - 1
    ]?.sessionReviewedDate;

  const isOutcomeChanged = !isEqual(
    ifspOutcomes.outcome,
    ifspOutcomes.originalOutcome,
  );

  const isSDPAndConsentChnaged = !isEqual(
    ifspSDPAndConsent.sdpAndConsent,
    ifspSDPAndConsent.originalSdpAndConsent,
  );

  const isTransitionChanged = !isEqual(
    ifspTransitionData.ifspTransitionData,
    ifspTransitionData.ifspOriginalTransitionData,
  );

  const isAnyServicesChangedWithoutIfspLock = !isEqual(
    ifspSDPAndConsent.sdpAndConsent.serviceDelivery,
    ifspSDPAndConsent.originalSdpAndConsent.serviceDelivery,
  );

  handleUpdateUnsavedChanges(
    isCommonAreaChanged ||
      isIfspReportChanged ||
      isDailyRoutineCreatedLocally ||
      isDailyRoutineChanged ||
      isDevelopmentalSummaryCreatedLocally ||
      isDevelopmentalSummaryChanged ||
      isFamilyConcernsCreatedLocally ||
      isFamilyConcernsChanged ||
      isHealthSummaryCreatedLocally ||
      isHealthSummaryChanged ||
      isOutcomeChanged ||
      isSDPAndConsentChnaged ||
      isTransitionChanged ||
      ifspUnsavedFields.isServiceDeliveryFieldsChanged ||
      ifspUnsavedFields.isOutComeProgressInfoFieldsChange ||
      ifspUnsavedFields.isHealthAndEligibilityFieldsChanged ||
      ifspUnsavedFields.isAnyTeamMemberFieldsChanged ||
      ifspUnsavedFields.isReporterFieldsChanged ||
      ifspUnsavedFields.isOtherDailyRoutineFieldsChanged,
  );

  return {
    isCommonAreaChanged,
    isIfspReportChanged,
    isDailyRoutineCreatedLocally,
    isDailyRoutineChanged,
    isDevelopmentalSummaryCreatedLocally,
    isDevelopmentalSummaryChanged,
    isFamilyConcernsCreatedLocally,
    isFamilyConcernsChanged,
    isHealthSummaryCreatedLocally,
    isHealthSummaryChanged,
    isLastDailyRoutineChangedAndNoCreatedDate,
    isDevelopmentalSummaryChangedAndNoCreatedDate,
    isFamilyConcernsChangedAndNoCreatedDate,
    isHealthSummaryChangedAndNoCreatedDate,
    isOutcomeChanged,
    isSDPAndConsentChnaged,
    isTransitionChanged,
    isAnyServicesChangedWithoutIfspLock,
    ifspUnsavedFields,
  };
};
